(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-classifieds-notifications]'));
  if (!roots.length) return;

  function updateBadge(root, count) {
    var badge = root.querySelector('[data-classifieds-notifications-count]');
    if (!badge) return;
    var unread = Math.max(0, Number(count) || 0);
    badge.hidden = unread === 0;
    badge.textContent = unread > 9 ? '9+' : String(unread);
  }

  function render(root, data) {
    updateBadge(root, data && data.unreadCount);
  }

  function load(root) {
    var endpoint = root.getAttribute('data-endpoint');
    if (!endpoint) return Promise.resolve();
    return fetch(endpoint, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load classifieds notifications');
        return response.json();
      })
      .then(function (data) { render(root, data); })
      .catch(function () { updateBadge(root, 0); });
  }

  roots.forEach(function (root) {
    load(root);
  });
}());
